<template>
  <div class="methodes-overzicht__methode">
    <h2>{{ methode.name }}</h2>
    <div class="methodes-overzicht__methode--intro" v-html="methode.description" ></div>

    <!-- methodes: in eerste regel: titel methode + 'democratische waarden' + button (aantal) tips  -->
    <div class="methodes-overzicht__firstrow" v-for="(row, j) in methode.values" :key="j.id" >
 
        <div :class="`waarde-tips-card`">
          <h3>{{ row.waarde }}</h3>
          <span class="quality-scores">
            <span class="star" v-for="n in parseInt(row.score)" :key="n"></span>
            <span class="star star--empty" v-for="n in parseInt(5-row.score)" :key="n+10"></span>
          </span>
          <p v-html="row.tekst"></p>
          <div class="tiprow" v-for="(tip,t) in row.tips" :key="t" v-if="showTip(tip.id)">
            <div class="tiprow__tiptext" :class="setDisabledClass(tip.id)" :ref="'tiptext_'+tip.id">
              <span class="red">Tip {{t+1}}:</span> 
              <div v-html="tip.value"></div>
            </div>
<!--      
            <div class="tiprow__checktip" v-if="view == 'PDF'">
              <input ref="tipcheck" type="checkbox" :value="tip.id" :id="tip.checkboxvalue" name="checktip" :checked="checkHidden(tip.id)"  v-on:change="changeTipChecked">
              <label :for="tip.checkboxvalue" :id="tip.id">in PDF</label>
            </div>
 -->          
          </div>
        </div>
   
    </div>
  
  </div>
</template>

<script>
export default {
  name: "MethodeCardPDF",

  data() {
    return {
      isTipChecked: true,
      hiddenTips: [],
    }
  },

  props: {
    methode: Object,
    view: String,
  },

  computed: {
  },

  methods: {
    changeTipChecked: function(event) {
      // use these variables
      // which tip is (un)checked?
      let tipid = event.target.value
      let isChecked = event.target.checked
      let tipRef = 'tiptext_'+event.target.value

      // Toggle disabled 
      this.$refs[tipRef][0].classList.toggle('disabled')
      
      if (isChecked) {
        this.hiddenTips.splice(this.hiddenTips.indexOf(tipid), 1);
      }

      if (!isChecked) {
        this.hiddenTips.push(tipid);
      }
      
      const parsed = JSON.stringify(this.hiddenTips);
      localStorage.setItem('hiddenTips', parsed);

    },

    checkHidden: function(tipid) {
      if (this.hiddenTips.indexOf(tipid.toString()) >= 0) {
        return false;
      } else {
        return true;
      }
    },

    setDisabledClass: function(tipid) {
      if (this.hiddenTips.indexOf(tipid.toString()) >= 0) {
        return 'disabled'
      } else {
        return '';
      }
    },

    showTip: function(tipid) {
      // tip altijd tonen bij PDF overzicht, 
      if (this.view == 'PDF') {
        return true
      } else {
        if (this.hiddenTips.indexOf(tipid.toString()) >= 0) {
          return false;
        } else {
          return true;
        }
      }
    },
  },

  mounted() {
    if (localStorage.getItem('hiddenTips')) {
      this.hiddenTips = JSON.parse(localStorage.getItem('hiddenTips'))
    } else {
    }

  }
};
</script>

